import { create } from "zustand";

type BackendStatusState = {
  isBackendUnavailable: boolean;
  markBackendUnavailable: () => void;
  clearBackendUnavailable: () => void;
};

export const useBackendStatus = create<BackendStatusState>((set) => ({
  isBackendUnavailable: false,
  markBackendUnavailable: () => set({ isBackendUnavailable: true }),
  clearBackendUnavailable: () => set({ isBackendUnavailable: false }),
}));
